import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { useHistory } from "react-router-dom";
import firebase from "../../FirebaseConfig.js";
import config from "../../Configurations.js";
import { buildLoginRedirectPath } from "util/routeAccess";
import {
  consumeShopifySsoToken,
  SHOPIFY_SSO_TOKEN_KEY,
} from "./consumeShopifySso";

const waitForFirebaseUser = () =>
  new Promise((resolve) => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    });
  });

const ShopifySso = () => {
  const history = useHistory();
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const fromQuery = (params.get("token") || "").trim();
      if (fromQuery) {
        try {
          sessionStorage.setItem(SHOPIFY_SSO_TOKEN_KEY, fromQuery);
        } catch (_) {}
        window.history.replaceState({}, "", "/auth/shopify");
      }

      let token = fromQuery;
      if (!token) {
        try {
          token = (sessionStorage.getItem(SHOPIFY_SSO_TOKEN_KEY) || "").trim();
        } catch (_) {
          token = "";
        }
      }
      if (!token) {
        setError(
          "This sign-in link is missing or expired. Open it again from Shopify Admin."
        );
        return;
      }

      const user = await waitForFirebaseUser();
      if (cancelled) return;
      if (!user) {
        history.replace(buildLoginRedirectPath("/auth/shopify"));
        return;
      }

      const result = await consumeShopifySsoToken(
        token,
        config.SHOPIFY_SSO_VERIFY_URL
      );
      if (cancelled) return;
      try {
        sessionStorage.removeItem(SHOPIFY_SSO_TOKEN_KEY);
      } catch (_) {}
      if (!result.ok) {
        setError(
          "This sign-in link is invalid or expired. Open it again from Shopify Admin."
        );
        return;
      }
      history.replace("/console/sonic-prospect");
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [history]);

  return (
    <div style={{ padding: 48, textAlign: "center" }}>
      {error ? <p>{error}</p> : <Spin />}
    </div>
  );
};

export default ShopifySso;
